var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CustomerPropositionsSummaryWidget.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-772fda96\"}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CustomerPropositionsSummaryWidget.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/keystone/components/Widgets/Customers/Summary/CustomerPropositionsSummaryWidget.vue
// module id = 635
// module chunks = 1